import { ButtonGroup, Menu, MenuItem, Stack } from "@mui/material";
import { curry, isEmpty, isFunction } from "lodash";
import { useState } from "react";
import Button from "./Styled/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AnimatedButton from "./Styled/AnimatedButton";

export function PrimaryIcons({ icons }: any) {
  const [anchorEls, setAnchorEls] = useState<any[]>(
    Array(icons.length).fill(null)
  );

  const openMenu = curry((index: number, e: any) =>
    setAnchorEls(
      anchorEls.map((anchorEl, i) => (index === i ? e.currentTarget : anchorEl))
    )
  );

  const closeMenu = curry((index: number, e: any) =>
    setAnchorEls(
      anchorEls.map((anchorEl, i) => (index === i ? null : anchorEl))
    )
  );

  return (
    <Stack spacing={1} direction="row">
      {icons?.map(
        (
          {
            icon: Icon,
            text,
            render = true,
            menuConfig = {},
            alwaysOpen = false,
            iconButtonProps = {},
            menuProps = {},
          }: any,
          i: number
        ) => {
          if (!render) return null;
          const isMenu = !isEmpty(menuConfig);
          const { menuItems, renderFn, onItemClick, messageOnEmpty } =
            menuConfig;

          return (
            <>
              <ButtonGroup>
                <AnimatedButton
                  key={i}
                  {...iconButtonProps}
                  onClick={(e) => {
                    if (isFunction(iconButtonProps?.onClick))
                      iconButtonProps.onClick(e);
                  }}
                >
                  <Icon fontSize="medium" />
                  {alwaysOpen ? (
                    <span style={{ marginLeft: "8px" }}>{text}</span>
                  ) : (
                    <span className="text">
                      <span style={{ marginLeft: "8px" }}>{text}</span>
                    </span>
                  )}
                </AnimatedButton>
                {isMenu && (
                  <AnimatedButton
                    sx={{ p: 0 }}
                    onClick={(e) => {
                      if (isMenu) openMenu(i, e);
                    }}
                  >
                    <KeyboardArrowDownIcon />
                  </AnimatedButton>
                )}
              </ButtonGroup>

              {isMenu && (
                <Menu
                  open={Boolean(anchorEls[i])}
                  onClose={closeMenu(i)}
                  anchorEl={anchorEls[i]}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    horizontal: "right",
                  }}
                  {...menuProps}
                >
                  {menuItems?.length
                    ? menuItems.map((menuItem: any) => (
                        <MenuItem onClick={(e) => onItemClick(e, menuItem)}>
                          {isFunction(renderFn) ? renderFn(menuItem) : menuItem}
                        </MenuItem>
                      ))
                    : messageOnEmpty || "No options available"}
                </Menu>
              )}
            </>
          );
        }
      )}
    </Stack>
  );
}
